module.exports = __webpack_public_path__ + "static/video-tab-adf5f25ecc4276b124c7c0b8a5cd4ed5.mp4";